import columns from '../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    ExternalConsignmentLinkColumn,
    ExternalReceptacleLinkColumn,
  } = columns(data);

  return [
    {
      Header: 'CARDIT',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'cardit.consignmentId')),
        new ExternalReceptacleLinkColumn(new TextColumn('Receptacle ID', 'cardit.receptacleId').withWidth(275)),
        new TextColumn('Sender', 'cardit.sender'),
        new TextColumn('Receiver', 'cardit.receiver'),
        new TextColumn('Origin country', 'cardit.originCountry'),
        new TextColumn('Origin airport', 'cardit.originAirport'),
        new TextColumn('Destination country', 'cardit.destinationCountry'),
        new TextColumn('Destination airport', 'cardit.destinationAirport'),
        new TextColumn('First leg conveyance reference', 'cardit.firstLegConveyanceReference'),
        new TextColumn('Last leg conveyance reference', 'cardit.lastLegConveyanceReference'),
      ],
    },
    {
      Header: 'RESDIT 74',
      columns: [
        new TextColumn('Sender', 'resdit74.sender'),
        new DateTimeColumn('Date', 'resdit74.date'),
        new TextColumn('Location', 'resdit74.location'),
      ],
    },
    {
      Header: 'RESDIT 21',
      columns: [
        new TextColumn('Sender', 'resdit21.sender'),
        new DateTimeColumn('Date', 'resdit21.date'),
        new TextColumn('Location', 'resdit21.location'),
      ],
    },
  ];
};
